import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { CardComponent } from '../../../components/card/card.component';
import { BackButtonComponent } from '../../../components/back-button/back-button.component';
import { AuthService } from '../../../services/auth.service';
import { lastValueFrom } from 'rxjs';
import { LogoImagesComponent } from '../../../components/logo-images/logo-images.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-verify-email',
  templateUrl: './verify-email.page.html',
  styleUrls: ['./verify-email.page.scss'],
  standalone: true,
  imports: [
    MatButtonModule,
    MatIconModule,
    RouterModule,
    CardComponent,
    BackButtonComponent,
    LogoImagesComponent,
    CommonModule
  ]
})
export class VerifyEmailPage implements OnInit {
  isLoading = true;
  isSuccess = false;
  errorMessage: string | null = null;
  verificationCode: string | null = null;
  private hasVerified = false; // Prevent duplicate requests

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.verificationCode = this.route.snapshot.queryParamMap.get('code');

    if (!this.verificationCode) {
      this.isLoading = false;
      this.errorMessage = 'Geen verificatiecode gevonden in de URL.';
      return;
    }

    // Only verify if we haven't already finished (prevent duplicate calls)
    if (!this.hasVerified && this.isLoading) {
      this.verifyEmail();
    }
  }

  private async verifyEmail() {
    // Prevent duplicate requests
    if (this.hasVerified) {
      return;
    }

    this.hasVerified = true;

    try {
      await lastValueFrom(this.authService.verifyEmail(this.verificationCode!));

      // If we reach here, the request was successful (200 status)
      this.isSuccess = true;
      document.title = 'E-mail geverifieerd - DON';
    } catch (error) {
      console.error('Email verification failed:', error);
      this.errorMessage = 'E-mail verificatie is mislukt. De code is mogelijk verlopen of ongeldig.';
    } finally {
      this.isLoading = false;
    }
  }

  goToLogin() {
    this.router.navigate(['/login']);
  }
}
